// extracted by mini-css-extract-plugin
export default {"selectDeliveryDate":"style_selectDeliveryDate__AwhB+","card":"style_card__fPirZ","active":"style_active__PNWr8"};